module.exports = __webpack_public_path__ + "media/images/icons/icon_attachment-8b95fa765979895620403bb608d30ff3.svg";